import React, { memo } from 'react'
import { CategoryTabBarContainer, CategoryTabBarScroller } from './styles'
import CategoryTabItem from './category-tab-item'
import type { CategoryTab, CategoryTabOption } from './types'

interface CategoryTabBarProps {
    tabs: CategoryTabOption[]
    activeTab: CategoryTab
    onTabChange: (tab: CategoryTab) => void
}

const CategoryTabBar: React.FC<CategoryTabBarProps> = ({ tabs, activeTab, onTabChange }) => {
    if (tabs.length <= 1) {
        return null
    }

    return (
        <CategoryTabBarContainer>
            <CategoryTabBarScroller>
                {tabs.map(tab => (
                    <CategoryTabItem
                        key={tab.key}
                        tab={tab}
                        isActive={tab.key === activeTab}
                        onTabChange={onTabChange}
                    />
                ))}
            </CategoryTabBarScroller>
        </CategoryTabBarContainer>
    )
}

export default memo(CategoryTabBar)
